/* eslint-disable */

function customSelect(el) {
    const summary = el.querySelector('button');
    const summary_value = summary.querySelector('.value');
    const inputs = el.querySelectorAll('input[type=radio]');
    const labels = el.querySelectorAll('label');
    const clicktouch = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
    const clickOut = (e) => !el.contains(e.target) && close();
    let inc = -1;
    let isOpen = false;
    const isAutocomplete = el.classList.contains("autcomplete") ? true : false;
    let value = "";
    let timeout = null;
    const items = el.querySelectorAll('li');

    const focus = e => {
        if (e.key === 'ArrowDown') inc++;
        if (e.key === 'ArrowUp') inc--;
        if (e.key === 'Enter') inc = 0;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter') {
            e.preventDefault();
            !isOpen && open();
            if (inc < 0) inc = labels.length - 1;
            if (inc > labels.length - 1) inc = 0;
            labels[inc].focus();
        } if (e.key === 'Tab') close();
        if (e.key === 'Escape') {
            close();
            setTimeout(() => summary.focus(), 10)
        }
        !el.contains(document.activeElement) && close();
    }

    const open = () => {
        isOpen = true;
        summary.setAttribute('aria-expanded', true);
        window.addEventListener(clicktouch, clickOut);

        if (isAutocomplete) {
            el.classList.add('valid');
            summary_value.focus();
            const length = summary_value.value.length;
            summary_value.setSelectionRange(length, length);
            value = summary_value.value;
            if (summary_value.value.length === 0) {
                items.forEach(item => {
                    item.style.display = 'flex'
                })
            } filter()
        }
    }

    const filter = () => {

        const regex = new RegExp(value, "gi");
        items.forEach(item => {
            item.style.display = regex.test(item.dataset.value) ? 'flex' : 'none'
        })

    }

    if (isAutocomplete) {
        summary_value.oninput = () => {
            value = summary_value.value.toLowerCase();
            timeout && clearTimeout(timeout);
            value = summary_value.value.toLowerCase();
            timeout = setTimeout(() => filter(), 200);
        }
    }

    const close = () => {
        inc = -1;
        isOpen = false;
        summary.setAttribute('aria-expanded', false);
        document.removeEventListener('keydown', focus);
        window.removeEventListener(clicktouch, clickOut);

        if (isAutocomplete) {
            let exist = false;
            inputs.forEach(item => {
                console.log(item.dataset.name, summary_value.value);
                if (item.dataset.name === summary_value.value) {
                    exist = true;
                    item.checked = true;
                }
                else {
                    item.checked = false;
                }
            });

            if (exist !== true) {
                summary_value.value = ""
            }

            if (summary_value.value.length === 0) el.classList.remove('valid');
        }
    }

    summary.onfocus = () => document.addEventListener('keydown', focus);
    summary.onclick = () => summary.getAttribute('aria-expanded') === 'true' ? close() : open();

    const click = (input) => {
        summary_value.value = input.parentNode.querySelector('label').innerHTML;
        el.classList.add('valid');
        close();
        setTimeout(() => summary.focus(), 10)
    }

    inputs.forEach(input => {
        input.onclick = (e) => click(input);
        input.onkeydown = (e) => (e.key === 'Enter') && click(label);
    });

    inputs.forEach(input => {
        if (input.checked) {
            summary_value.value = el.querySelector(`label[for="${input.id}"]`).innerHTML;
            el.classList.add('valid');
        }
    });

    setTimeout(() => el.classList.add('ready'), 300)
}

export default customSelect;
